var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditableTable',{attrs:{"data":_vm.data,"column-configs":_vm.columnConfigs}})}
var staticRenderFns = []

export { render, staticRenderFns }